<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4
            slot="header"
            class="card-title text-left"
            style="padding: 0px; margin: 0px;"
          >
            Editar Escala
          </h4>

          <div>
            <h5
              class="card-title text-left mt-0 pt-0"
              style="padding: 0px; margin: 0px;"
            >
              <b>Funcionário:</b> {{ funcionarioSelecionado.nome }}
            </h5>
          </div>

          <div
            class="d-flex justify-content-center justify-content-sm-between flex-wrap mt-3"
          >
            <div>
              <base-button
                type="info"
                class="animation-on-hover"
                @click="voltar()"
              >
                <i class="tim-icons icon-minimal-left"></i> Voltar
              </base-button>
            </div>
          </div>

          <div style="margin-top: 20px;">
            <div class="row">
              <div class="col-md-4 text-left">
                <h4 class="card-title">De</h4>
                <base-input
                  type="date"
                  :max="moment(dataFinal).format('YYYY-MM-DD')"
                  v-model="dataInicial"
                  :disabled="true"
                />
              </div>

              <div class="col-md-4 text-left">
                <h4 class="card-title">Até</h4>
                <base-input
                  type="date"
                  :min="moment(dataInicial).format('YYYY-MM-DD')"
                  v-model="dataFinal"
                  :disabled="true"
                />
              </div>

              <div class="col-md-4 text-left">
                <h4 class="card-title">Quantidades de Colunas</h4>
                <base-input>
                  <el-select
                    class="select-success"
                    size="large"
                    v-model="qtdColunasSelecionadas"
                  >
                    <el-option class="select-success" label="2" value="2"
                      >2</el-option
                    >
                    <el-option class="select-success" label="4" value="4"
                      >4</el-option
                    >
                    <el-option class="select-success" label="6" value="6"
                      >6</el-option
                    >
                    <el-option class="select-success" label="8" value="8"
                      >8</el-option
                    >
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row" style="margin-top: 10px;">
              <div class="col-md-3 text-left">
                <h4 class="card-title">Entrada / Saída 1</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada1"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida1"
                  />
                </div>
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas == 2"
              >
                <h4 class="card-title">Descanso</h4>
                <input type="time" class="form-control" v-model="descanco" />
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas >= 4"
              >
                <h4 class="card-title">Entrada / Saída 2</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada2"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida2"
                  />
                </div>
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas >= 6"
              >
                <h4 class="card-title">Entrada / Saída 3</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada3"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida3"
                  />
                </div>
              </div>

              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas == 8"
              >
                <h4 class="card-title">Entrada / Saída 4</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada4"
                  />
                  <input
                    type="time"
                    class="form-control"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida4"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12 text-left">
                <h4 class="card-title">
                  Selecione os dias para preencher os horários
                </h4>
              </div>

              <div class="col-md-12 d-flex justify-content-between flex-wrap">
                <base-checkbox v-model="allDias" @input="marcarTodosDias">
                  Todos os dias
                </base-checkbox>

                <base-checkbox v-model="domingo">Domingo</base-checkbox>
                <base-checkbox v-model="segunda">Segunda</base-checkbox>
                <base-checkbox v-model="terca">Terça</base-checkbox>
                <base-checkbox v-model="quarta">Quarta</base-checkbox>
                <base-checkbox v-model="quinta">Quinta</base-checkbox>
                <base-checkbox v-model="sexta">Sexta</base-checkbox>
                <base-checkbox v-model="sabado">Sábado</base-checkbox>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <base-button
                  :disabled="!dataInicial || !dataFinal"
                  block
                  type="primary"
                  @click="preencherHorarios()"
                >
                  Preencher Horários
                </base-button>
              </div>
            </div>

            <div
              class="row d-flex justify-content-between mt-2"
              v-if="diaSelecionar.length > 0"
            >
              <div class="col-md-6">
                <base-input
                  class="text-left"
                  label="Selecione os dias da semana de FOLGA"
                >
                  <select
                    v-model="diaSem"
                    @change="aplicarDiaSemana(diaSem)"
                    class="form-control"
                  >
                    <option value="0">Domingo</option>
                    <option value="1">Segunda</option>
                    <option value="2">Terça</option>
                    <option value="3">Quarta</option>
                    <option value="4">Quinta</option>
                    <option value="5">Sexta</option>
                    <option value="6">Sábado</option>
                  </select>
                </base-input>
              </div>

              <div class="col-md-6">
                <base-input
                  class="text-left"
                  label="Selecione os dias pares ou ímpares de FOLGA"
                >
                  <select
                    v-model="folgaParImpar"
                    @change="aplicarParesDiaSemana()"
                    class="form-control"
                  >
                    <option value="0">Pares</option>
                    <option value="1">Ímpares</option>
                  </select>
                </base-input>
              </div>
            </div>

            <div class="row" v-if="diaSelecionar.length > 0">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Folga</th>
                        <th>Dia</th>
                        <th>Data</th>
                        <th>Qtd</th>
                        <th>Entrada 1</th>
                        <th>Saída 1</th>

                        <th v-if="possuiQtd2()">Descanso</th>

                        <th v-if="possuiQtd4()">Entrada 2</th>
                        <th v-if="possuiQtd4()">Saída 2</th>

                        <th v-if="possuiQtd6()">Entrada 3</th>
                        <th v-if="possuiQtd6()">Saída 3</th>

                        <th v-if="possuiQtd8()">Entrada 4</th>
                        <th v-if="possuiQtd8()">Saída 4</th>

                        <th>Ações</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="item in diaSelecionar" :key="item.id">
                        <td>
                          <base-checkbox v-model="item.folga"></base-checkbox>
                        </td>

                        <td>{{ item.dia }}</td>
                        <td>{{ moment(item.data).format("DD/MM/YYYY") }}</td>
                        <td>{{ item.qtdColunas || "-" }}</td>

                        <td>
                          <input
                            v-if="item.qtdColunas"
                            type="time"
                            class="form-control"
                            v-model="item.entrada1"
                          />
                        </td>

                        <td>
                          <input
                            v-if="item.qtdColunas"
                            type="time"
                            class="form-control"
                            v-model="item.saida1"
                          />
                        </td>

                        <td v-if="possuiQtd2()">
                          <input
                            v-if="item.qtdColunas == 2"
                            type="time"
                            class="form-control"
                            v-model="item.descanco"
                          />
                        </td>

                        <td v-if="possuiQtd4()">
                          <input
                            v-if="item.qtdColunas >= 4"
                            type="time"
                            class="form-control"
                            v-model="item.entrada2"
                          />
                        </td>

                        <td v-if="possuiQtd4()">
                          <input
                            v-if="item.qtdColunas >= 4"
                            type="time"
                            class="form-control"
                            v-model="item.saida2"
                          />
                        </td>

                        <td v-if="possuiQtd6()">
                          <input
                            v-if="item.qtdColunas >= 6"
                            type="time"
                            class="form-control"
                            v-model="item.entrada3"
                          />
                        </td>

                        <td v-if="possuiQtd6()">
                          <input
                            v-if="item.qtdColunas >= 6"
                            type="time"
                            class="form-control"
                            v-model="item.saida3"
                          />
                        </td>

                        <td v-if="possuiQtd8()">
                          <input
                            v-if="item.qtdColunas >= 8"
                            type="time"
                            class="form-control"
                            v-model="item.entrada4"
                          />
                        </td>

                        <td v-if="possuiQtd8()">
                          <input
                            v-if="item.qtdColunas >= 8"
                            type="time"
                            class="form-control"
                            v-model="item.saida4"
                          />
                        </td>

                        <td>
                          <el-tooltip
                            content="Excluir"
                            effect="light"
                            :open-delay="300"
                            placement="top"
                          >
                            <base-button
                              @click.native="handleDelete(item)"
                              class="remove btn-link"
                              type="danger"
                              size="sm"
                              icon
                            >
                              <i class="tim-icons icon-simple-remove"></i>
                            </base-button>
                          </el-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <base-button
                  type="success"
                  block
                  class="animation-on-hover"
                  style="margin: 0px 5px 0px 5px;"
                  @click="editarEscalasDepartamentos()"
                >
                  Salvar
                </base-button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Modal from "@/components/Modal.vue";

export default {
  name: "editar-escalas",

  props: {
    funcionarioSelecionado: {
      type: Object,
      default: () => ({}),
    },

    dadosEscalas: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },

  data() {
    return {
      folgaParImpar: null,
      diaSem: null,

      dataInicial: "",
      dataFinal: "",

      allDias: true,
      domingo: true,
      segunda: true,
      terca: true,
      quarta: true,
      quinta: true,
      sexta: true,
      sabado: true,

      entrada1: "",
      entrada2: "",
      entrada3: "",
      entrada4: "",

      saida1: "",
      saida2: "",
      saida3: "",
      saida4: "",

      descanco: "",
      qtdColunasSelecionadas: 4,

      diaSelecionar: [],
      isLoading: false,
    };
  },

  mounted() {
    this.carregarDados();
  },

  watch: {
    domingo: "atualizarAllDias",
    segunda: "atualizarAllDias",
    terca: "atualizarAllDias",
    quarta: "atualizarAllDias",
    quinta: "atualizarAllDias",
    sexta: "atualizarAllDias",
    sabado: "atualizarAllDias",
  },

  methods: {
    voltar() {
      this.$emit("voltar", true);
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title,
          text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    moment(data) {
      return moment(data);
    },

    verifyDay(day) {
      switch (day) {
        case 0:
          return "Domingo";
        case 1:
          return "Segunda";
        case 2:
          return "Terça";
        case 3:
          return "Quarta";
        case 4:
          return "Quinta";
        case 5:
          return "Sexta";
        case 6:
          return "Sábado";
        default:
          return "";
      }
    },

    marcarTodosDias() {
      this.domingo = this.allDias;
      this.segunda = this.allDias;
      this.terca = this.allDias;
      this.quarta = this.allDias;
      this.quinta = this.allDias;
      this.sexta = this.allDias;
      this.sabado = this.allDias;
    },

    atualizarAllDias() {
      this.allDias =
        this.domingo &&
        this.segunda &&
        this.terca &&
        this.quarta &&
        this.quinta &&
        this.sexta &&
        this.sabado;
    },

    existeDiaSelecionado() {
      return (
        this.domingo ||
        this.segunda ||
        this.terca ||
        this.quarta ||
        this.quinta ||
        this.sexta ||
        this.sabado
      );
    },

    diaEstaSelecionado(diaNumerico) {
      const diasSelecionados = {
        0: this.domingo,
        1: this.segunda,
        2: this.terca,
        3: this.quarta,
        4: this.quinta,
        5: this.sexta,
        6: this.sabado,
      };

      return diasSelecionados[diaNumerico];
    },

    calcularQtdColunasPorDia(dados) {
      if (dados.entrada_4 && dados.saida_4) return 8;
      if (dados.entrada_3 && dados.saida_3) return 6;
      if (dados.entrada_2 && dados.saida_2) return 4;
      if (dados.entrada_1 && dados.saida_1) return 2;
      return null;
    },

    possuiQtd2() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) === 2);
    },

    possuiQtd4() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) >= 4);
    },

    possuiQtd6() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) >= 6);
    },

    possuiQtd8() {
      return this.diaSelecionar.some((d) => Number(d.qtdColunas) >= 8);
    },

    carregarColunas() {
      const escala = this.dadosEscalas.dados[0];

      if (escala.entrada_4 && escala.saida_4) return 8;
      if (escala.entrada_3 && escala.saida_3) return 6;
      if (escala.entrada_2 && escala.saida_2) return 4;
      if (escala.entrada_1 && escala.saida_1) return 2;

      return 4;
    },

    carregarEntradasSaidas() {
      const escala = this.dadosEscalas.dados[0];

      if (escala.entrada_1 && escala.saida_1) {
        this.entrada1 = this.moment(escala.entrada_1).format("HH:mm");
        this.saida1 = this.moment(escala.saida_1).format("HH:mm");
      }

      if (escala.entrada_2 && escala.saida_2) {
        this.entrada2 = this.moment(escala.entrada_2).format("HH:mm");
        this.saida2 = this.moment(escala.saida_2).format("HH:mm");
      }

      if (escala.entrada_3 && escala.saida_3) {
        this.entrada3 = this.moment(escala.entrada_3).format("HH:mm");
        this.saida3 = this.moment(escala.saida_3).format("HH:mm");
      }

      if (escala.entrada_4 && escala.saida_4) {
        this.entrada4 = this.moment(escala.entrada_4).format("HH:mm");
        this.saida4 = this.moment(escala.saida_4).format("HH:mm");
      }

      if (escala.descanco) {
        this.descanco = escala.descanco;
      }
    },

    carregarDados() {
      this.dataInicial = this.moment(this.dadosEscalas.data_inicial).format(
        "YYYY-MM-DD",
      );

      this.dataFinal = this.moment(this.dadosEscalas.data_final).format(
        "YYYY-MM-DD",
      );

      this.diaSelecionar = [];

      for (const dados of this.dadosEscalas.dados) {
        this.diaSelecionar.push({
          id: dados.id,
          dia: dados.dia_da_semana,
          diaNumerico: dados.dia_da_semana_numerico,
          data: this.moment(dados.data).format("YYYY-MM-DD"),
          folga: dados.folga == 0 ? false : true,
          qtdColunas: this.calcularQtdColunasPorDia(dados),

          entrada1: dados.entrada_1
            ? this.moment(dados.entrada_1).format("HH:mm:ss")
            : null,
          saida1: dados.saida_1
            ? this.moment(dados.saida_1).format("HH:mm:ss")
            : null,

          entrada2: dados.entrada_2
            ? this.moment(dados.entrada_2).format("HH:mm:ss")
            : null,
          saida2: dados.saida_2
            ? this.moment(dados.saida_2).format("HH:mm:ss")
            : null,

          entrada3: dados.entrada_3
            ? this.moment(dados.entrada_3).format("HH:mm:ss")
            : null,
          saida3: dados.saida_3
            ? this.moment(dados.saida_3).format("HH:mm:ss")
            : null,

          entrada4: dados.entrada_4
            ? this.moment(dados.entrada_4).format("HH:mm:ss")
            : null,
          saida4: dados.saida_4
            ? this.moment(dados.saida_4).format("HH:mm:ss")
            : null,

          descanco: dados.descanco || "",
        });
      }

      this.diaSelecionar = this.diaSelecionar.sort((a, b) => {
        if (a.data < b.data) return -1;
        if (a.data > b.data) return 1;
        return 0;
      });

      this.qtdColunasSelecionadas = this.carregarColunas();
      this.carregarEntradasSaidas();
    },

    validarData(dataEnviada) {
      const anoAtual = this.moment().year();

      const dataValida = this.moment(dataEnviada).isValid();
      const ano = Number(dataEnviada.split("-")[0]);

      console.log("dataEnviada: ", dataEnviada);
      console.log("dataValida: ", dataValida);
      console.log("ano: ", ano);

      if (!dataValida || ano < 1900 || ano > anoAtual) {
        return false;
      }

      return true;
    },

    preencherHorarios() {
      if (
        !this.validarData(this.dataInicial) ||
        !this.validarData(this.dataFinal)
      ) {
        this.showSwal(
          "auto-close",
          "Data inválida",
          "Informe uma data válida.",
          "error",
        );

        return;
      }

      if (!this.existeDiaSelecionado()) {
        this.showSwal(
          "auto-close",
          "Atenção",
          "Selecione pelo menos um dia da semana!",
          "warning",
        );
        return;
      }

      const qtd = Number(this.qtdColunasSelecionadas);

      this.diaSelecionar = this.diaSelecionar.map((item) => {
        if (!this.diaEstaSelecionado(item.diaNumerico)) {
          return item;
        }

        return {
          ...item,
          qtdColunas: qtd,

          entrada1: this.entrada1,
          saida1: this.saida1,

          descanco: qtd === 2 ? this.descanco : "",

          entrada2: qtd >= 4 ? this.entrada2 : null,
          saida2: qtd >= 4 ? this.saida2 : null,

          entrada3: qtd >= 6 ? this.entrada3 : null,
          saida3: qtd >= 6 ? this.saida3 : null,

          entrada4: qtd >= 8 ? this.entrada4 : null,
          saida4: qtd >= 8 ? this.saida4 : null,
        };
      });
    },

    aplicarParesDiaSemana() {
      this.diaSelecionar = this.diaSelecionar.map((data) => {
        const dia = moment(data.data).date();
        const resultado = dia % 2 == Number(this.folgaParImpar);

        if (resultado) {
          data.folga = true;
        }

        return data;
      });
    },

    aplicarDiaSemana(dia) {
      this.diaSelecionar = this.diaSelecionar.map((data) => {
        if (dia == data.diaNumerico) {
          data.folga = true;
        }

        return data;
      });
    },

    handleDelete(item) {
      const th = this;
      th.isLoading = true;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregado: this.funcionarioSelecionado.id,
        id: item.id,
      };

      this.axios
        .post("/api/escalas/deletarDiaEscalasFuncionario", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;

          if (response.data.status == "success" && response.data.data.status) {
            th.diaSelecionar = th.diaSelecionar.filter(
              (ds) => ds.id !== item.id,
            );
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              response.data.data.err || "Erro ao excluir dia",
              "error",
            );
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao excluir dia!", "error");
        });
    },

    editarEscalasDepartamentos() {
      const th = this;
      this.isLoading = true;

      const datas = this.diaSelecionar.map((value) => {
        const item = {
          ...value,
          folga: value.folga ? 1 : 0,
          qtdColunas: value.qtdColunas || null,
          descanco: value.descanco || "",
        };

        if (item.descanco === "") delete item.descanco;

        if (item.entrada2 === "" || item.entrada2 === null)
          delete item.entrada2;
        if (item.entrada3 === "" || item.entrada3 === null)
          delete item.entrada3;
        if (item.entrada4 === "" || item.entrada4 === null)
          delete item.entrada4;

        if (item.saida2 === "" || item.saida2 === null) delete item.saida2;
        if (item.saida3 === "" || item.saida3 === null) delete item.saida3;
        if (item.saida4 === "" || item.saida4 === null) delete item.saida4;

        return item;
      });

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_funcionario: this.funcionarioSelecionado.id,
        data_inicial: this.dataInicial,
        data_final: this.dataFinal,
        datas,
      };

      this.axios
        .post("/api/escalas/atualizarModeloEscalasFuncionario", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;

          if (response.data.status == "success" && response.data.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Escala editada com sucesso!",
              "success",
            );
            th.voltar();
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              response.data.data.err || "Erro ao editar escala",
              "error",
            );
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao editar escala!", "error");
        });
    },
  },
};
</script>
